import styled from 'styled-components';

export const $StockTableViewsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
`;

export const $ViewSelector = styled.div`
  max-width: 20rem;
  min-width: 12rem;
`;

export const $ModalField = styled.div`
  margin-bottom: 1rem;
`;

export const $ModalLabel = styled.label`
  display: block;
  margin-bottom: 0.4rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #334155;
`;
